import NavigateBeforeOutlinedIcon from "@mui/icons-material/NavigateBeforeOutlined";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import { Grid, Typography } from "@mui/material";
import { groupBy } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getVetAppointmentsByIdAndFilter } from "../../../redux/reducers/clinicSlice";
import { storeVetCalScreenDetails } from "../../../redux/reducers/mixedSlice";
import {
  createTimeSlots,
  getDateList,
  getDatesInRange,
  getHourRanges,
  getStartAndEndDatesOfWeekByType,
  getTypeByAppointmentType,
  isTimeBetween,
} from "../../../util/function";
import VetAndUpcomingAppointments from "../../CommonScreens/VetAndUpcomingAppointments/VetAndUpcomingAppointments";
import VetBookAppointment from "./VetBookAppointment";

const VetCalendar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timeRef = useRef(null);
  const [selectedType, setSelectedType] = useState("today");
  const [timeList, setTimeList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dateList, setDateList] = useState([]);
  const [reqApnts, setReqApnts] = useState(null);
  const [modalBookVisible, setModalBookVisible] = useState(false);
  const [prevWeekNumber, setPrevWeekNumber] = useState(0);
  const [nextWeekNumber, setNextWeekNumber] = useState(0);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const vetDetails = useSelector((state) => state?.clinic?.vet);
  const vetAppointments = useSelector(
    (state) => state?.clinic?.vetAppointments
  );

  useEffect(() => {
    const reqTimes = createTimeSlots("00:00", "23:59", 60);
    setTimeList(reqTimes);
    getDateLists();
  }, []);

  useEffect(() => {
    if (timeRef?.current) {
      timeRef?.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [timeList]);

  useEffect(() => {
    getReqAppointments();
  }, [vetAppointments]);

  useEffect(() => {
    const id = location?.state?.vet?.doctorId ?? profile?.id;
    let url = `${id}?type=${selectedType}`;
    if (selectedType === "date") {
      url = url + `&date=${moment(selectedDate).format("YYYY-MM-DD")}`;
    }
    if (selectedType === "week") {
      if (prevWeekNumber > 0) url = `${id}?type=prev&num=${prevWeekNumber}`;
      if (nextWeekNumber > 0) url = `${id}?type=next&num=${nextWeekNumber}`;
      if (nextWeekNumber > 0 || prevWeekNumber > 0) {
        const reqDates = getDatesInRange(
          getStartAndEndDatesOfWeekByType({
            key: nextWeekNumber > 0 ? "next" : "prev",
            weeks: prevWeekNumber > 0 ? prevWeekNumber : nextWeekNumber,
          })?.startDate,
          getStartAndEndDatesOfWeekByType({
            key: nextWeekNumber > 0 ? "next" : "prev",
            weeks: prevWeekNumber > 0 ? prevWeekNumber : nextWeekNumber,
          })?.endDate
        );
        setDateList(reqDates);
      }
      if (nextWeekNumber === 0 && prevWeekNumber === 0) {
        const reqDates = getDatesInRange(
          new Date(),
          new Date(new Date().setDate(new Date().getDate() + 6))
        );
        setDateList(reqDates);
      }
    }
    dispatch(getVetAppointmentsByIdAndFilter(url));
    //for storing details to call socket
    dispatch(
      storeVetCalScreenDetails({
        selectedType,
        userId: profile?.id,
        selectedDate,
      })
    );
  }, [selectedType, selectedDate, prevWeekNumber, nextWeekNumber]);

  const getReqAppointments = () => {
    const reqList = [];
    timeList?.forEach((tm) => {
      const slots = vetAppointments?.filter((ap) =>
        isTimeBetween(
          moment(new Date(ap?.appointmentdateTime)).format("HH:mm"),
          tm
        )
      );
      slots?.reverse()?.forEach((sl) => {
        const timeBet = isTimeBetween(
          moment(new Date(sl?.appointmentdateTime)).format("HH:mm"),
          tm
        );
        if (timeBet) {
          if (sl?.serviceType === "Surgery") {
            const hrRange = getHourRanges(sl?.surgeryTimes);
            if (hrRange?.length > 0) {
              hrRange?.forEach((hr) => {
                reqList.push({ ...sl, time: hr });
              });
            }
          } else {
            reqList.push({ ...sl, time: `${tm}-${tm?.split(":")?.[0]}:59` });
          }
        }
      });
    });
    setReqApnts(groupBy(reqList, "time"));
  };

  const getDateLists = async () => {
    const dates = await getDateList();
    setDateList(dates);
  };

  const handleDateChange = (value) => {
    const reqDate = new Date(selectedDate);
    reqDate.setDate(
      value === "add" ? reqDate.getDate() + 1 : reqDate.getDate() - 1
    );
    setSelectedDate(reqDate);
  };

  const handleWeekChange = (value) => {
    if (value === "add") {
      if (prevWeekNumber > 0) {
        setPrevWeekNumber(prevWeekNumber - 1);
        setNextWeekNumber(0);
      } else {
        setNextWeekNumber(nextWeekNumber + 1);
        setPrevWeekNumber(0);
      }
    } else {
      if (nextWeekNumber > 0) {
        setNextWeekNumber(nextWeekNumber - 1);
        setPrevWeekNumber(0);
      } else {
        setNextWeekNumber(0);
        setPrevWeekNumber(prevWeekNumber + 1);
      }
    }
  };

  const handleSelectWeek = () => {
    setNextWeekNumber(0);
    setPrevWeekNumber(0);
    setSelectedType("week");
  };

  const navDetailsPage = (det) => {
    navigate(`/clinic-pet-details`, {
      state: { appointment: { appoinment: det } },
    });
  };

  return (
    <VetAndUpcomingAppointments
      vetId={location?.state?.vet?.doctorId ?? profile?.id}
      active="vetCalendar"
    >
      <Grid container className="ph2">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="back-white p10"
        >
          <div className="flex-row">
            <div className="flex-start">
              <div className="flex-center">
                <Typography
                  className={`font-bold fs14 cursor day-type-box ${
                    selectedType === "today" ? "black" : "gray2"
                  }`}
                  onClick={() => setSelectedType("today")}
                >
                  Today
                </Typography>
              </div>
            </div>
            <div className="flex1-center">
              <div className="flex-row">
                <div className="flex-center">
                  <NavigateBeforeOutlinedIcon
                    className={`calendar-arrow ${
                      selectedType === "date" || selectedType === "week"
                        ? "cursor"
                        : "no-cursor"
                    }`}
                    onClick={() =>
                      selectedType === "date"
                        ? handleDateChange("minus")
                        : handleWeekChange("minus")
                    }
                  />
                  <Typography className="text-bold mh20">
                    {selectedType === "today"
                      ? moment(new Date()).format("DD MMM YYYY")
                      : selectedType === "date"
                      ? moment(new Date(selectedDate)).format("DD MMM YYYY")
                      : selectedType === "week" &&
                        (prevWeekNumber > 0 || nextWeekNumber > 0)
                      ? `${moment(
                          new Date(
                            getStartAndEndDatesOfWeekByType({
                              key: nextWeekNumber > 0 ? "next" : "prev",
                              weeks:
                                prevWeekNumber > 0
                                  ? prevWeekNumber
                                  : nextWeekNumber,
                            })?.startDate
                          )
                        ).format("DD MMM")} - ${moment(
                          new Date(
                            new Date(
                              getStartAndEndDatesOfWeekByType({
                                key: nextWeekNumber > 0 ? "next" : "prev",
                                weeks:
                                  prevWeekNumber > 0
                                    ? prevWeekNumber
                                    : nextWeekNumber,
                              })?.endDate
                            )
                          )
                        ).format("DD YYYY")}`
                      : `${moment(new Date()).format("DD MMM")} - ${moment(
                          new Date(new Date().setDate(new Date().getDate() + 6))
                        ).format("DD YYYY")}`}
                  </Typography>
                  <NavigateNextOutlinedIcon
                    className={`calendar-arrow ${
                      selectedType === "date" || selectedType === "week"
                        ? "cursor"
                        : "no-cursor"
                    }`}
                    onClick={() =>
                      selectedType === "date"
                        ? handleDateChange("add")
                        : handleWeekChange("add")
                    }
                  />
                </div>
              </div>
            </div>
            <div className="w20Per">
              <div className="flex-center">
                <Typography
                  className={`font-bold fs14 cursor day-type-box ${
                    selectedType === "date" ? "black" : "gray2"
                  }`}
                  onClick={() => setSelectedType("date")}
                >
                  Day
                </Typography>
                <Typography
                  className={`font-bold fs14 cursor day-type-box ${
                    selectedType === "week" ? "black" : "gray2"
                  }`}
                  onClick={() => handleSelectWeek()}
                >
                  Week
                </Typography>
              </div>
            </div>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="mt3 back-white card-columns"
        >
          <div
            className={`${
              selectedType !== "week" ? "w100Per" : "scrollx w160Per"
            }`}
          >
            {selectedType === "week" ? (
              <>
                <div className="flex-row h70AliCen">
                  <div className="w10Per" />

                  <div className="w1Per">
                    <div className="flex-center">
                      <div className="box-ver-split" />
                    </div>
                  </div>
                  {dateList?.length > 0 &&
                    dateList?.map((dt, i) => (
                      <>
                        <div
                          className="w20Per ph5 pv2"
                          key={i + dt?.name + "docname"}
                        >
                          <div className="flex-center">
                            <Typography className="text-bold">
                              {moment(new Date(dt)).format("ddd DD")}
                            </Typography>
                          </div>
                        </div>
                        <div className="w1Per" key={i + dt?.name + "verbar"}>
                          <div className="flex-center">
                            <div className="box-ver-split" />
                          </div>
                        </div>
                      </>
                    ))}
                </div>
                <div className="box-hor-split" />
              </>
            ) : null}

            {timeList?.length > 0 &&
              timeList?.map((tm, i) => {
                const timeMatch = reqApnts?.[`${tm}-${tm?.split(":")?.[0]}:59`];
                const currTime = moment().format("HH:mm");
                const timeIsBet = isTimeBetween(currTime, tm);

                return (
                  <div key={i} ref={timeIsBet ? timeRef : null}>
                    {selectedType !== "week" ? (
                      <div className="flex-row h70AliCen">
                        <div className="w10Per">
                          <div
                            className="flex-center cursor"
                            onClick={() => setModalBookVisible(true)}
                          >
                            <Typography
                              className={`font-bold fs12 ${
                                timeIsBet ? "red-color" : "gray6"
                              }`}
                            >
                              {tm}
                            </Typography>
                          </div>
                        </div>
                        <div className="w1Per">
                          <div className="flex-center">
                            <div className="box-ver-split" />
                          </div>
                        </div>
                        <div className="w89Per ph5 pv2">
                          <div
                            className={`flex-row ${
                              timeMatch?.length > 1 ? "jus-con-spa-bet" : ""
                            }`}
                          >
                            {timeMatch?.slice(0, 4)?.map((timMa, index) => {
                              const apntStatus = getTypeByAppointmentType(
                                timMa?.appointmentStatus
                              );
                              return (
                                <div
                                  className={`cursor 
                                ${
                                  timeMatch?.length === 1
                                    ? "w100Per"
                                    : timeMatch?.length === 2
                                    ? "w49Per"
                                    : timeMatch?.length === 3
                                    ? "w32Per"
                                    : "w23Per"
                                }`}
                                  key={index + timMa?.appointmentdateTime}
                                  onClick={() => navDetailsPage(timMa)}
                                >
                                  <div
                                    className={
                                      timMa?.serviceType === "Surgery"
                                        ? "cal-gray-box"
                                        : timMa?.serviceType === "Vaccination"
                                        ? "cal-green-box"
                                        : timMa?.serviceType === "Consultation"
                                        ? "cal-blue-box"
                                        : timMa?.serviceType === "Emergency"
                                        ? "cal-red-box"
                                        : "cal-rose-box"
                                    }
                                  >
                                    <div className="flex-row">
                                      <div className="flex-column jus-con-spa-bet h50">
                                        <div className="flex-row">
                                          {timMa?.petImage ? (
                                            <img
                                              src={timMa?.petImage}
                                              alt=""
                                              className="pet-card-img2"
                                            />
                                          ) : (
                                            <div className="flex-center h20img">
                                              <Typography className="font-bold fs30 white-color capitalize">
                                                {timMa?.petName?.[0]}
                                              </Typography>
                                            </div>
                                          )}
                                          <div
                                            className={`ml10 txt-regular white-color fs8 card-consultation flex-center ${
                                              timMa?.appointmentType ===
                                              "Physical"
                                                ? "card-con-blue-back"
                                                : timMa?.appointmentType ===
                                                  "Virtual"
                                                ? "virtual-bg-color"
                                                : "card-con-gray-back"
                                            }`}
                                          >
                                            {timMa?.appointmentType}
                                          </div>
                                          <Typography
                                            className={`ml5 font-bold fs8 cal-time ${
                                              timMa?.serviceType ===
                                              "Vaccination"
                                                ? "green-back"
                                                : timMa?.serviceType ===
                                                  "Consultation"
                                                ? "card-bot-blue-back"
                                                : timMa?.serviceType ===
                                                  "Emergency"
                                                ? "card-bot-red-back"
                                                : "card-bot-rose-back"
                                            }`}
                                          >
                                            {moment(
                                              new Date(
                                                timMa?.appointmentdateTime
                                              )
                                            ).format("HH:mm")}
                                          </Typography>

                                          {timeMatch?.length < 4 ? (
                                            <Typography
                                              className={`ml5 fs8 txt-regular white-color flex-center upcom-app-box ${
                                                timMa?.appointmentStatus?.toLowerCase() ===
                                                "canceled"
                                                  ? "card-con-red-back"
                                                  : timMa?.appointmentStatus?.toLowerCase() ===
                                                    "completed"
                                                  ? "card-con-green-back"
                                                  : timMa?.appointmentStatus?.toLowerCase() ===
                                                      "consultation" ||
                                                    timMa?.appointmentStatus?.toLowerCase() ===
                                                      "finalize"
                                                  ? "card-top-yellow-color"
                                                  : "card-top-orange-color"
                                              }
                                              }`}
                                            >
                                              {apntStatus}
                                            </Typography>
                                          ) : null}
                                        </div>
                                        <div className="flex-row">
                                          <Typography className="font-bold fs10 capitalize">
                                            {`${timMa?.serviceType ?? ""} | ${
                                              timMa?.petName
                                            }`}
                                          </Typography>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                            {timeMatch?.length > 4 ? (
                              <div className="flex-center font-bold fs14 ml20">
                                + {timeMatch?.length - 4} more
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="flex-row h70AliCen"
                        ref={timeIsBet ? timeRef : null}
                      >
                        <div className="w10Per">
                          <div className="flex-center">
                            <Typography
                              className={`font-bold fs12 ${
                                timeIsBet ? "red-color" : "gray6"
                              }`}
                            >
                              {tm}
                            </Typography>
                          </div>
                        </div>
                        <div className="w1Per">
                          <div className="flex-center">
                            <div className="box-ver-split" />
                          </div>
                        </div>
                        {dateList?.length > 0 &&
                          dateList?.map((dt, i) => {
                            const timeMatch =
                              reqApnts?.[`${tm}-${tm?.split(":")?.[0]}:59`];
                            const reqList = timeMatch?.filter((rl) => {
                              return (
                                rl?.appointmentDate ===
                                (typeof dt === "string"
                                  ? dt
                                  : moment(new Date(dt)).format("YYYY-MM-DD"))
                              );
                            });

                            let aptType = "Others";
                            if (reqList?.length > 0) {
                              const sur = reqList?.find(
                                (dd) => dd?.serviceType === "Surgery"
                              );
                              const emer = reqList?.find(
                                (dd) => dd?.serviceType === "Emergency"
                              );
                              const vacc = reqList?.find(
                                (dd) => dd?.serviceType === "Vaccination"
                              );
                              const consData = reqList?.find(
                                (dd) => dd?.serviceType === "Consultation"
                              );

                              aptType = sur
                                ? "Surgery"
                                : emer
                                ? "Emergency"
                                : vacc
                                ? "Vaccination"
                                : consData
                                ? "Consultaion"
                                : "Others";
                            }

                            return (
                              <>
                                <div className="w20Per ph5 pv2">
                                  {reqList?.length > 0 ? (
                                    <div
                                      className={
                                        aptType === "Surgery"
                                          ? "cal-gray-box"
                                          : aptType === "Vaccination"
                                          ? "cal-green-box"
                                          : aptType === "Consultaion"
                                          ? "cal-blue-box"
                                          : aptType === "Emergency"
                                          ? "cal-red-box"
                                          : "cal-rose-box"
                                      }
                                    >
                                      <div className="flex-column jus-con-spa-bet h50">
                                        <div className="flex-row">
                                          {reqList?.length > 0
                                            ? reqList
                                                ?.slice(0, 2)
                                                ?.map((st, si) => (
                                                  <Typography
                                                    className={`${
                                                      si !== 0 ? "ml2" : ""
                                                    } font-bold fs8 cal-time ${
                                                      aptType === "Vaccination"
                                                        ? "green-back"
                                                        : aptType ===
                                                          "Consultaion"
                                                        ? "card-bot-blue-back"
                                                        : aptType ===
                                                          "Emergency"
                                                        ? "card-bot-red-back"
                                                        : "card-bot-rose-back"
                                                    }`}
                                                  >
                                                    {moment(
                                                      new Date(
                                                        st?.appointmentdateTime
                                                      )
                                                    ).format("HH:mm")}
                                                  </Typography>
                                                ))
                                            : null}
                                        </div>
                                        {reqList?.length > 2 ? (
                                          <Typography className="font-bold fs10 card-black">
                                            + {reqList?.length - 2} more
                                          </Typography>
                                        ) : (
                                          <div />
                                        )}
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                                <div
                                  className="w1Per"
                                  key={i + dt?.name + "verbar"}
                                >
                                  <div className="flex-center">
                                    <div className="box-ver-split" />
                                  </div>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    )}
                    <div className="box-hor-split" />
                  </div>
                );
              })}
          </div>
        </Grid>
      </Grid>
      <VetBookAppointment
        modalVisible={modalBookVisible}
        setModalBookVisible={setModalBookVisible}
        selectVet={vetDetails}
        selectedDate={selectedDate}
      />
    </VetAndUpcomingAppointments>
  );
};

export default VetCalendar;
